// extracted by mini-css-extract-plugin
module.exports = {"Container":"Footer_Container__wmMdq","Footer":"Footer_Footer__3pSVU","Social":"Footer_Social__102h0","Line":"Footer_Line__3REk4"};